module.exports = __webpack_public_path__ + "static/media/down_chevron.bf3e03b0.svg";